import React, { useContext } from "react";
import themeContext from "../../context/theme/ThemeContext";

export const SampleReportTemplatesIcon = (props) => {
  const { themeName,getThemeColor } = useContext(themeContext);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
    >
      <path
        d="M5.71508 0H9.14357V4.00163C9.14357 4.94853 9.91119 5.71615 10.8581 5.71615H14.8592V13.7117C14.8592 14.9743 13.8357 15.9978 12.5732 15.9978H8.76221C10.376 14.8598 11.4302 12.9812 11.4302 10.8564C11.4302 7.38444 8.61556 4.56983 5.14357 4.56983C4.54919 4.56983 3.97408 4.65232 3.42905 4.80648V2.28603C3.42905 1.02349 4.45254 0 5.71508 0Z"
        // fill={props.active ? "white" : "#7B7B7B"}
        fill={themeName != "light"?props.active?"white":"#bfbfbf":getThemeColor("icon-color")}
      />
      <path
        d="M10.8581 4.57314H14.8554L10.2967 0H10.2866V4.00163C10.2866 4.31726 10.5425 4.57314 10.8581 4.57314Z"
        // fill={props.active ? "white" : "#7B7B7B"}
        fill={themeName != "light"?props.active?"white":"#bfbfbf":getThemeColor("icon-color")}
      />
      <path
        d="M10.2871 10.8564C10.2871 13.6971 7.98429 16 5.14357 16C2.30286 16 0 13.6971 0 10.8564C0 8.01571 2.30286 5.71285 5.14357 5.71285C7.98429 5.71285 10.2871 8.01571 10.2871 10.8564ZM5.14357 7.99888C4.82794 7.99888 4.57207 8.25476 4.57207 8.57039V10.8564C4.57207 11.1721 4.82794 11.4279 5.14357 11.4279C5.45921 11.4279 5.71508 11.1721 5.71508 10.8564V8.57039C5.71508 8.25476 5.45921 7.99888 5.14357 7.99888ZM5.14357 13.8568C5.53812 13.8568 5.85796 13.537 5.85796 13.1425C5.85796 12.7479 5.53812 12.4281 5.14357 12.4281C4.74903 12.4281 4.42919 12.7479 4.42919 13.1425C4.42919 13.537 4.74903 13.8568 5.14357 13.8568Z"
        // fill={props.active ? "white" : "#7B7B7B"}
        fill={themeName != "light"?props.active?"white":"#bfbfbf":getThemeColor("icon-color")}
      />
    </svg>
  );
};
